@if (topBarVisible) {
  <nav id="topnav"  class="navbar navbar-expand-lg navbar-dark bg-dark">
    <button class="btn btn-dark" type="button" (click)="toggleMenu()" ><i class="fas fa-bars"></i></button>
    <span class="navbar-brand"  [innerText]="pageTitle" ></span>
  </nav>
}
<off-canvas-menu [current]="tv" [facility]="tv?.facility" [isOpened]="isOpened" (toggleMenu)="toggleMenu()"></off-canvas-menu>
<div class="tv-view">
  <router-outlet></router-outlet>
</div>
<display-message/>